// The gate desk's nav. Composed by the STAFF portal beside lib and fin.
//
// A guard holds only `guard:*`, and every LIB and FIN nav item carries a perm —
// so buildNav filters those away, their sections empty, and their modules drop
// out entirely. "A guard signs in and sees only the guard module" is therefore
// the existing filter doing its job, not a special case anywhere.
import { ShieldCheck, ScanLine } from "lucide-solid";
import type { ModuleManifest } from "@erp/auth-kit/nav";

export const guardStaffNav: ModuleManifest = {
  id: "guard",
  module: "guard",
  label: "Gate desk",
  icon: ShieldCheck,
  to: "/gate/verify",
  sections: [
    {
      id: "guard-entry",
      label: "Entry",
      items: [
        { id: "guard-verify", label: "Verify a card", to: "/gate/verify", icon: ScanLine, perm: "guard:verify" },
      ],
    },
  ],
};
